import React, { useEffect, useState } from 'react';
import { Table, Space, Button, Input, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { useDispatch, useSelector } from 'react-redux';
import { deleteBusinessCategories, getAllBusinessCategories, getContactUs, updateContactStatus } from '../../actions/business';

interface DataType {
    key: string;
    companyName: string;
    contactName: string;
    email: string;
    resolved: boolean;
    abn: string;
    id : string;
}

interface CategoryType {
    type?: string;
    handleUpdate?: any;
    handleEdit?: any;
}

const BusinessCategoryTable = ({ handleUpdate, handleEdit }: CategoryType) => {
    const { businessCategory } = useSelector((state:any) => state?.Business)
    const [data, setData] = useState<DataType[]>(businessCategory);
    const [pagination, setPagination] = useState({ totalItems: 0 });
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [reload, setReload] = useState(false);

    const dispatch = useDispatch(); 
    const { isLoading } = useSelector((state: any) => state?.General);

    const fetchData =()=> {
        dispatch(
            getAllBusinessCategories({}, (resp: any) => {
                if (resp?.success) {
                    setData(resp?.data);
                    setPagination(resp?.total);
                }
            })
        );
    }

    useEffect(() => {
        fetchData()
    }, [page, pageSize, reload, dispatch]);

    const handleTableChange = (pagination: any) => {
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const handleDelete = (item:any) => {
        dispatch(
            deleteBusinessCategories(item, (resp: any) => {
                if (resp) {
                    fetchData();
                }
            })
        );
    }

    const columns: ColumnsType<DataType> = [
        {
            title: 'Category Name',
            dataIndex: 'label',
            key: 'label',
            align: 'left',
            width: 200,
        },
        {
            title: 'Category Key',
            dataIndex: 'value',
            key: 'value',
            align: 'left',
            width: 200,
        },
        {
            title: 'Action',
            key: 'action',
            align: 'center',
            width: 100,
            render: (_, record) => (
                <Space size="middle">
                        <Button
                            type="link"
                            icon={<EditOutlined style={{ color: '#F47523'}} />}
                            onClick={() => handleEdit(record)}
                        />
                        <Popconfirm title="Are you sure you want to delete this category?" onConfirm={()=> handleDelete(record)}>
                            <Button
                                type="link"
                                icon={<DeleteOutlined style={{ color: '#F47523'}} />}
                            />
                        </Popconfirm>
                </Space>
            ),
        },
    ];
    

    return (
        <div className="responsivetable">
            <Table
                size="small"
                columns={columns}
                dataSource={data}
                loading={isLoading}
                pagination={{
                    total: pagination?.totalItems || 0,
                    pageSize,
                    current: page,
                    showSizeChanger: true,
                    pageSizeOptions: ['20', '50'],
                }}
                scroll={{ y: 264, x: 800 }}
                onChange={handleTableChange}
                rowKey="id"
            />
        </div>
    );
};

export default BusinessCategoryTable;
